import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CardProducto } from '../components/CardProducto';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import Cookies from 'universal-cookie';

import "./estilos.css";
import axios from 'axios';

function LandingPage() {

    const cookies = new Cookies();
    const accessToken = cookies.get('accesToken');
    const [arrayProductosNuevos, setArrayProductosNuevos] = useState([]);
    const [arrayProductosDestacados, setArrayProductosDestacados] = useState([]);
    const [arrayProductosPromocionales, setArrayProductosPromocionales] = useState([]);
    const [arrayBanner, setArrayBanner] = useState([]);

    const imagenPublicidad = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/';

    const settingsMarcas = {
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 2,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    };
    const settingsBanners = {
        pauseOnHover: true,
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const settingsDestacados = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1238,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 440,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    }

    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 3000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1048,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 440,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    };

    const arrayMarcas = [
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/HOLCIM.png',
            nombre: 'HOLCIM',
            link: 'HOLCIM'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/CELTA.png',
            nombre: 'CELTA',
            link: 'CELTA'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/SIKA.png',
            nombre: 'SIKA',
            link: 'SIKA'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/EUROCERAMICA.png',
            nombre: 'EUROCERAMICA',
            link: 'EUROCERAMICA'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/CERAMICA ITALIA.png',
            nombre: 'CERAMICA ITALIA',
            link: 'CERAMICA ITALIA'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/GERFOR.png',
            nombre: 'GERFOR',
            link: 'GERFOR'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/SIDOC.png',
            nombre: 'SIDOC',
            link: 'SIDOC'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/GOYA.png',
            nombre: 'GOYA',
            link: 'GOYA'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/CINTANDINA.png',
            nombre: 'CINTANDINA',
            link: 'CINTANDINA'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/PINTURAS PINTUCO.png',
            nombre: 'PINTURAS PINTUCO',
            link: 'PINTURAS PINTUCO'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/BLACK + DECKER.png',
            nombre: 'BLACK + DECKER',
            link: 'BLACK + DECKER'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/ESAB.png',
            nombre: 'ESAB',
            link: 'ESAB'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/SWEISS.png',
            nombre: 'SWEISS',
            link: 'SWEISS'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/FURIUS.png',
            nombre: 'FURIUS',
            link: 'FURIUS'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/ELITE.png',
            nombre: 'ELITE',
            link: 'ELITE'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/IRWIN.png',
            nombre: 'IRWIN',
            link: 'IRWIN'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/DEWALT.png',
            nombre: 'DEWALT',
            link: 'DEWALT'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/STANLEY.png',
            nombre: 'STANLEY',
            link: 'STANLEY'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/REJIPLAS.png',
            nombre: 'REJIPLAS',
            link: 'REJIPLAS'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/TERINSA.png',
            nombre: 'TERINSA',
            link: 'TERINSA'
        },
    ];

    const queryFetch = async () => {
        try {
            const urlBanner = process.env.REACT_APP_SERVER + '/api/v1/products/banner';
            const dataBanner = await axios.post(urlBanner, { pagina: 'landingPage' }, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            const Banner = dataBanner.data;
            const url = process.env.REACT_APP_SERVER + '/api/v1/products/landingPage';
            const response = await axios.get(url);
            const data = response.data;
            let nuevo = data.filter(element => element.categoria === 'Nuevo');
            let destacado = data.filter(element => element.categoria === 'Destacado');
            let promocional = data.filter(element => element.categoria === 'Promocional');
            setArrayBanner(Banner);
            setArrayProductosNuevos(nuevo);
            setArrayProductosDestacados(destacado);
            setArrayProductosPromocionales(promocional);
            window.scroll({
                top: 0,
                left: 100,
                behavior: 'auto'
            });
        } catch (error) {
            console.log('Ocurrió error en la consulta' + error);
        }
    }

    useEffect(() => {
        queryFetch();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Header />
            <Container fluid className="containerProductos">
                <Container fluid className='containerBanner'>
                    <Row aria-hidden="true">
                        <Col className="m-0 p-0">
                            <div className='divFlechas'>
                                <Slider {...settingsBanners} >
                                    {
                                        arrayBanner.map((fila, id) =>
                                            <Col sm={10} key={id}>
                                                <a key={id} target={"_new"} href={fila.telefono}>
                                                    <img fallback={'Cargando'} src={imagenPublicidad + fila.pagina} alt="bannerPrincipal" className="img-fluid" width={'100%'} height={'100%'} />
                                                </a>
                                            </Col>
                                        )
                                    }
                                </Slider>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid="md" className="containerProductos pb-3 mt-1">
                    <Row className="align-items-center">
                        <Col xs={12}>
                            <img loading='lazy' fallback={<p>Cargando</p>} src={imagenPublicidad + 'promocionales.webp'} alt="promocionales" className="img-fluid" style={{ maxHeight: 'max-content' }} />
                        </Col>
                    </Row>
                </Container>
                <Container fluid className='containerPromocionales pb-3'>
                    <Container>
                        <Row>
                            <Col className="divFlechasProductos">
                                <Slider {...settings}>
                                    {
                                        arrayProductosPromocionales.map((item, i) =>
                                            <Fragment key={i}>
                                                <CardProducto propiedades={item} />
                                            </Fragment>
                                        )
                                    }
                                </Slider>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                <Container fluid="md" className="containerProductos mt-1 mb-1">
                    <Row className="align-items-center">
                        <Col xs={12}>
                            <img loading='lazy' fallback={<p>Cargando</p>} src={imagenPublicidad + 'nuevos.webp'} alt="nuevos" className="img-fluid" style={{ maxHeight: 'max-content' }} />
                        </Col>
                    </Row>
                </Container>
                <Container fluid className='containerNuevos pb-3'>
                    <Container>
                        <Row>
                            <Col xs={12} className="divFlechasProductosNuevos">
                                <Slider {...settings}>
                                    {
                                        arrayProductosNuevos.map((item, i) =>
                                            <Fragment key={i}>
                                                <CardProducto propiedades={item} />
                                            </Fragment>
                                        )
                                    }
                                </Slider>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                <Container fluid className="containerDestacados pb-3 mt-1">
                    <Row className="align-items-center">
                        <Col xs={6} sm={4}>
                            <img loading='lazy' fallback={<p>Cargando</p>} src={imagenPublicidad + 'destacados.webp'} alt="destacados" className="img-fluid" style={{ maxHeight: 'max-content' }} />
                        </Col>
                        <Col xs={11} sm={7} className="divFlechasProductosDestacados ms-3 mt-3">
                            <Slider {...settingsDestacados}>
                                {
                                    arrayProductosDestacados.map((item, i) =>
                                        <Fragment key={i}>
                                            <CardProducto propiedades={item} />
                                        </Fragment>
                                    )
                                }
                            </Slider>
                        </Col>
                    </Row>
                </Container>
                <Container fluid="md">
                    <Container>
                        <Row className="align-items-center">
                            <Col xs={11} className="carruselMarca divFlechasProductosNuevos">
                                <Slider {...settingsMarcas}>
                                    {
                                        arrayMarcas.map((item, i) =>
                                            <Row key={i}>
                                                <Col className='imgMarcas' >
                                                    <img loading='lazy' fallback={<p>Cargando</p>} id={i} className="mx-auto img-fluid imgMarca" src={item.imagen} alt={item.nombre} width={'100%'} height={'100%'} />
                                                </Col>
                                            </Row>
                                        )
                                    }
                                </Slider>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                { /*<label>window.screen.width {window.screen.width} y window.screen.height {window.screen.height}</label> */}
            </Container>
            <Footer />
        </>
    )
}

export { LandingPage };